import React, { PureComponent } from 'react'
import { Pane, Heading, Avatar, Menu, Popover, Position, toaster } from 'evergreen-ui'
import Auth from '../../Auth'
// eslint-disable-next-line
import { User } from '../../types'


// class HeaderButton extends React.Component {
//     render() {
//         return <a className={"normalizeHref"} href={this.props.route}>
//             <Pane display="flex" flexDirection="row" marginRight={30}>
//                 <Heading color="#FFF" size={400}> {this.props.name} </Heading>
//             </Pane>
//         </a>
//     }
// }
interface Props {
    user: User
}

interface State {
    width: number
    height: number
}

export default class componentName extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            width: 0,
            height: 0
        }
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    isMobile = () => {
        return this.state.width < 640
    }

    render() {
        return (
            <Pane display="flex" padding={16} paddingRight={25} style={{ background: "#001529", color: "white", textDecoration: "none" }}>
                <Pane flex={1} marginLeft={10} marginRight={30} alignItems="center" paddingTop={5} display="flex">
                    <Heading size={600}>
                        <a className={"normalizeHref"} href="./">
                            <img alt="logo" width={154} height={25} src={require("../../images/white_compact_word_logo.png")}></img>
                        </a>
                    </Heading>
                </Pane>

                {/* <Pane marginTop={-2.5} borderRight={"1px solid #AAA"} style={{ color: "white" }} marginRight={30} alignItems="center" display="flex"> */}
                {/* <HeaderButton name="Home" icon="home" route={window.location.origin + "/"}></HeaderButton> */}
                {/* <HeaderButton name="Heatmaps" icon="home" route={window.location.origin + "/heatmap"}></HeaderButton> */}
                {/* <HeaderButton name="Detection History" icon="home" route={window.location.origin + "/history"}></HeaderButton> */}
                {/* <HeaderButton name="Recorded Footage" icon="home" route={window.location.origin + "/recorded"}></HeaderButton> */}
                {/* <HeaderButton name="FAQ" icon="download" route="https://usesafewatch.com/page-faq.html"></HeaderButton> */}
                {/* <HeaderButton name="Help" icon="help" onClick={() => { toaster.notify('Help not available right now. Use the chat at the bottom to contact support.') }}></HeaderButton> */}
                {/* </Pane> */}

                <Popover
                    position={Position.BOTTOM_LEFT}
                    content={
                        <Menu>
                            <Menu.Group>
                                <Menu.Item onClick={() => { window.location.replace(window.location.origin + "/profile") }} icon="people">Profile</Menu.Item>
                                <Menu.Item onClick={() => { toaster.notify('Use the chat at the bottom right to contact support.') }} icon="help">Support</Menu.Item>
                            </Menu.Group>
                            <Menu.Divider />
                            <Menu.Group>
                                <Menu.Item onClick={(new Auth()).logout} icon="log-out" intent="danger">
                                    Logout
                                </Menu.Item>
                            </Menu.Group>
                        </Menu>
                    }>

                    <Pane style={{ "cursor": "pointer" }} display="flex" flexDirection="row">
                        {!this.isMobile() ?
                            <Pane paddingTop={12.5} paddingRight={20}>
                                <Heading color="white" size={400}>{this.props.user && this.props.user.name}</Heading>
                            </Pane> : <></>}
                        <Pane>
                            <Avatar name={this.props.user && this.props.user.name} size={40} />
                        </Pane>
                    </Pane>
                </Popover>
            </Pane>
        )
    }
}
